import ScrollNavbar from "reusables/layouts/ScrollNavbar";

function SuppliesNavbar() {
  return <ScrollNavbar title="Supplies" />;
}

export default SuppliesNavbar;
